module.exports = __webpack_public_path__ + "static/media/noData.315b2d7c.png";